<template>
	<section v-if="items.length" class="main-content align-center">
		<div class="row faq">
			<h2>{{ header }}</h2>
			<div v-for="item in items" :key="item.ID" class="columns column12 faq-item">
				<collapse :header="item.question" :content="item.answer" />
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.row {
	overflow: hidden;
	width: 100%;
	display: inline-block;
	font-size: 0;
	vertical-align: top;
	padding-bottom: 75px;
	text-align: left;
	max-width: 960px;

	&:last-child {
		padding-bottom: 0;
	}

	h2 {
		margin: 10px 0 30px;
		text-align: center;
	}
}

@media (max-width: 960px) {
	.faq-item {
		padding: 5px 15px;
	}
}
</style>
